// extracted by mini-css-extract-plugin
module.exports = {"container":"blocks-heading-container","heading":"blocks-heading-heading"};